import React, { useEffect, useRef, useState } from 'react';
import { renderAsync } from 'docx-preview';
import LoadingSpinner from './LoadingSpinner';

const DocxPreview = ({ fileUrl }) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    const renderDocx = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Fetch the blob/arrayBuffer from the local object URL
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error('Failed to fetch document content');
        const arrayBuffer = await response.arrayBuffer();

        if (!active) return;
        if (containerRef.current) {
          containerRef.current.innerHTML = ''; // Clear previous contents
          await renderAsync(arrayBuffer, containerRef.current, null, {
            className: "docx-preview-content",
            inWrapper: true,
            ignoreWidth: false,
            ignoreHeight: false,
            experimental: true
          });
        }
        setLoading(false);
      } catch (err) {
        console.error('Error rendering docx:', err);
        if (active) {
          setError(err.message || 'Failed to render DOCX file.');
          setLoading(false);
        }
      }
    };

    renderDocx();

    return () => {
      active = false;
    };
  }, [fileUrl]);

  return (
    <div className="w-full h-full overflow-auto bg-slate-100 flex flex-col items-center p-4 relative min-h-[400px]">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/90 z-10">
          <div className="flex flex-col items-center gap-3">
            <LoadingSpinner size="lg" />
            <span className="text-xs text-gray-500 font-medium animate-pulse">Rendering Word Document...</span>
          </div>
        </div>
      )}
      {error && (
        <div className="bg-red-50 text-red-700 p-4 rounded-lg max-w-md text-center mt-10">
          <p className="font-semibold mb-2">Error Displaying Document</p>
          <p className="text-xs">{error}</p>
        </div>
      )}
      <div 
        ref={containerRef} 
        className="w-full max-w-4xl bg-white shadow-lg rounded border border-gray-200 docx-container-body" 
      />
    </div>
  );
};

export default DocxPreview;
